<template>
    <section class="emailView">
        <ol class="breadcrumb">
            <li  v-if=" this.$route.fullPath == '/emails/:id'" class="breadcrumb-item cursor-pointer" @click="changeTab('ALL')">{{ $t('lang.label.allemails') }}</li>
            <li class="breadcrumb-item active">{{ selected.response_subject }}</li>
        </ol>
        <main class="">
                <LoadingSpinner v-if="loading" />
                <div class="contentCenter all" v-if="!loading">
                    <div class="row">
                        <div class="col-sm-12 mb-5" v-if="selected.business_contact_id">
                        </div>

                    <div class="col-sm-3 col-md-3 mb-5">   
                                    <div v-if="(currentUser.role_id == 1 ||  currentUser.role_id == 8 )
                                            && selected.response_id !== undefined
                                            && selected.link_id !== undefined
                                            && selected.business_contact_id !== undefined
                                            && selected.id !== undefined"> 
                                             <small
                                              v-if="tagging"
                                              class="loadingres d-flex p-2 spinner-border loading-spinner mx-auto"
                                              role="status"
                                            >
                                            </small>
                                        <div class="row my-1 card">
                                            <button  :disabled="tagging" class="btn btn-sm bg-primary text-white" @click="retag(false,true)">
                                              <i class="icon-tag"></i> ONLY TAG
                                            </button>
                                            <small class="p-2">We only auto tag.</small>
                                        </div>
                                      
                                        <div class="row my-1 card">
                                            <button  :disabled="tagging" class="btn btn-sm bg-danger text-white" @click="retag(false,false)">
                                               <i class="icon-warning"></i> AUTO TAG
                                            </button>
                                            <small class="p-2 text-danger">IMPORTANT: we will replicate every step of tagging an email, for example send email if its positive or create tasks, and different actions like that. This means that if you click two times, we will send your message to the reply email two times.</small>
                                        </div>
                                        <div class="row my-1 card">
                                            <button  :disabled="tagging" class="btn btn-sm  text-white" style="background-color: #77bb40;" @click="openAiTag()">
                                              <i class="icon-tag"></i> AI TAG
                                            </button>
                                            <span v-if="!openAiLoading && openAiResponse!=''" class="mr-2 p-2">Response:{{openAiResponse}}</span>
                                            <span v-if="openAiLoading"
                                                        class="loadingres spinner-border loading-spinner ml-2"></span>
                                        </div>
                                        <div class="card my-3"></div> 
                                        <div class="row">Manual TAG:</div>


                                        <div class="row my-1 card">
                                            <button  :disabled="tagging"  class="btn btn-sm btn-light" @click="retag([99,1],false)">
                                                Anti SPAM <i class="icon-warning"></i>
                                            </button>
                                        </div> 

                                        <div 
                                        v-if="emailresponsestatus.length > 0 && hideButtons(st.id)" 
                                        class="row my-1 card" v-for="st in emailresponsestatus">
                                            <button   :disabled="tagging"  class="btn btn-sm"
                                                :class="'btn-'+st.color" @click="retag([st.id],false)">
                                           {{st.description}}
                                            </button>
                                        </div> 


                                        <div class="row my-1 card" v-if="false">
                                            <button  :disabled="tagging"  class="btn btn-sm btn-secondary" @click="retag([101],false)">
                                                Not working here
                                            </button>
                                        </div> 


                                        <div v-if="showtags" class="card p-2">
                                        Result:
                                        <strong class="mx-1" v-for="w in worddetected">{{w}}</strong>
                                        <div>
                                        <span
                                          v-for="(tag, ind) in tags[selected.id]"
                                          class="mx-1 badge text-white badge-success"
                                          v-if="tag  && ind !== 'analyzed'"
                                        >
                                          {{ ind }}
                                        </span>
                                        <span
                                          v-for="(tag, ind) in tags[selected.id]"
                                          class="mx-1 badge text-white badge-danger"
                                          v-if="!tag"
                                        >
                                          {{ ind }}</span
                                        >
                                        </div>
                                        <pre class="mt-2" v-html="highlightedText(worddetected[0])">
                                        </pre>
                                      </div>
                                    </div>

                                    <div v-if="selected.link_id !== null">
                                    <p class="p-3 font-weight-bold">{{ $t('lang.label.thisemailislinkedto') }}</p>
                                    <div class="card p-4">
                                        <div>
                                            <div class="">
                                                <h4 class="info font-weight-bold">{{this.selected.business_name}}</h4>
                                                <p class="mt-2" v-if="selected.business_contact_email">{{this.selected.business_contact_email}}</p><!--contact-->
                                                <p class="mt-2" v-else>{{ $t('lang.label.thereisnocontactassociatedwiththisemail') }}</p>
                                                <div class=" mt-2">
                                                     <router-link  :to="'/opportunities/' + selected.link_id" target="_blank">
                                                    Oliver:
                                                    <span 
                                                    v-if="this.selected.link_status_name == 'Negative'"
                                                    class="badge mr-1" :class="statusBadge(this.selected.link_status_name)">ON <i class="icon-play"></i></span><br>
                                                    <span 
                                                    v-if="this.selected.link_status_name == 'Positive'"
                                                    class="badge mr-1" :class="statusBadge(this.selected.link_status_name)">OFF <i class="icon-stop"></i></span><br>
                                                        Opportunity: 
                                                        <span class="badge mr-1" :class="statusBadge(this.selected.campaign_name)">{{this.selected.campaign_name}}</span>
                                                    </router-link>
                                                </div>
                                                <div>
                                                    <button type="button" class="btn btn-sm btn-danger mt-2" @click="changeStatusBusinessContactAction(7,selected.client_id)">
                                                        <span class="">{{ $t('lang.button.donotcontact') }}</span>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="line"></div>
                                             <div class="mt-2" v-if="!this.selected.business_contact_email">
                                                        <div class="d-flex justify-content-between align-items-center">
                                                        <p class="mb-2 font-weight-bold">{{ $t('lang.label.associatetoacontact') }}</p>
                                                        <button class="c-pointer btn btn-success ml-2 my-2" @click="getContacts()"> <i class="icon-user-plus"></i></button>
                                                        </div>
                                                        <div class="content-search-opp">                                                    
                                                                <ul class="" >
            
                                                                    <li v-for="(contact, key) in oppContacts" :key="key"  @click="contactSelect(contact)">
                                                                        <div class="pt-2 pb-2 c-pointer">
                                                                        <div class="row">
                                                                            
                                                                            <div class="col-md-5 col-lg-3 col-xl-2 d-flex  align-items-center">
                                                                                <div class=" position-relative pt-1">
                                                                                    <div class="">
                                                                                        <span class="icoCircle mail list text-uppercase"><span>
                                                                                        <small>{{contact.email | firstLetters}}  </small>
                                                                                        </span></span>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-md-7 col-lg-9 col-xl-10 d-flex  align-items-center">
                                                                                <span class="d-block ml-2"><small class="font-weight-bold ">{{contact.email}} </small></span> 
                                                                            </div>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li class="divider"></li>
                                                                </ul>
                                                        </div>
                                                        <div class="mt-2">
                                                                <div class="pt-2 pb-3"  v-if="contactSelected">
                                                                    <div class="w-100 d-flex justify-content-between align-items-center">
                                                                        <span class="text-left font-weight-bold">{{this.contactSelected.email}} </span>
                                                                        <i  @click="resetContactSelected" class="icon-minus-square-o c-pointer"></i>
                                                                    </div>
                                                                </div>
                                                                <button  @click="associateBusinessContact" class="btnSet positive d-block mb-2 text-center w-100 btn btn-sm btn-primary themed-button">
                                                                    <span>Link contact</span>
                                                                </button>
                                                        </div>  
                                            </div>  
                                        </div>
                                    </div>
                                    <ActionButtons  
                                        v-if="selected.business_contact_email !== null"
                                        :link="{'id': this.selected.link_id}"
                                        :status="'define status'"
                                        @qualifiedOpportunity="qualifiedOpportunity($event)"
                                        @disqualifiedOpportunity="disqualifiedOpportunity($event)"
                                        @doNotContactBusiness="doNotContactBusiness($event)"
                                        @deleteBusiness="deleteBusiness($event)"
                                        />
                                  
                                </div> <!--//if-->
                                <div v-else>
                                   
                                    <p class="p-3 font-weight-bold">{{ $t('lang.label.thisemailhasnotbeenlinkedtoanyopportunityyet') }}</p>
                                    <div class="card p-4">
                                        <div>
                                            <div class="">
                                                <form class="form-inline form-search">
                                                    <div class="input-group w-100">
                                                    {{$t('lang.search.keywords')}}
                                                    <input
                                                    class="w-100 form-control d-block"
                                                    type="search"
                                                    aria-label="Search"
                                                    v-model="searchOpportunities"
                                                    />

                                                    <button  @click="confirmSearch"
                                                            class="btnSet ml-2 positive d-block mb-2 text-center btn btn-sm btn-primary themed-button"
                                                            type="button">
                                                            <span class="icon-search"></span>
                                                        </button>
                                                    <button  @click="autoLink(selected.response_id,selected.response_to,selected.id)"
                                                            class="btnSet ml-2 positive d-block mb-2 text-center btn btn-sm btn-primary themed-button"
                                                            type="button">
                                                            <span class="icon-link"></span> Auto link
                                                            <span v-if="autolink">{{autolink}}</span>
                                                        </button>
                                                       
                                                    </div>
                                                    <p class="alert alert-danger w-100 mt-2" v-if="errors.length">
                                                        <ul >
                                                        <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
                                                        </ul>
                                                    </p>
                                                    
                                                </form>                                                
                                            </div>
                                            <div class="content-search-opp">                                                    
                                                    <ul class="list-result-opp" >
                                                        <LoadingSpinner v-if="loadingOpportunities" />
                                                        <li class="text-right" v-if="opportunities.length > 0">
                                                            <span  @click="resetSearch"><i class="icon-times-circle"></i></span>
                                                        </li>
                                                        <li v-for="(opportunity, key) in opportunities" :key="key"  >
                                                           {{opportunity.business_name}} - {{opportunity.campaign_name}} - {{opportunity.creation_date}}
                                                           <i
                                                           class="icon-link btn-sm btn-primary" @click="opportunitySelected(opportunity)"></i>
                                                                 <router-link 
                                                                 class="ml-2 icon-eye btn-sm btn-secondary" :to="'/opportunities/' + opportunity.id" target="_blank"
                                                                >
                                                            </router-link>
                                                        </li>
                                                    </ul>
                                            </div>

                                            <div class="mt-2">
                                                    <div class="pt-2 pb-3"  v-if="oppSelected">
                                                        <div class="w-100 d-flex justify-content-between align-items-center">
                                                            <span class="text-left font-weight-bold">{{oppSelected.business_name}} - {{oppSelected.campaign_name}}</span>
                                                            <i  @click="resetOppSelected" class="icon-minus-square-o c-pointer"></i>
                                                               <router-link 
                                                                 class="ml-2 icon-eye btn-sm btn-secondary" :to="'/opportunities/' + oppSelected.id" target="_blank"
                                                                >
                                                            </router-link>
                                                        </div>

                                                    <button  v-on:click.prevent="associateOpportunity" :disabled="isDisabled" class="btnSet ml-2 positive d-block mb-2 text-center btn btn-sm btn-primary themed-button">
<span><span class="icon-check"></span></span>
</button>
                                                    </div>
                                                    
                                            </div>
                                            
                                        </div>
                                    </div>

                                </div>

                                <div v-if="selected.business_contact_email !== null">
                                    <!-- Calificar un email -->
                                    <!-- <div class="mt-2" v-if=" selected.status !== 'positive' ">                         
                                        <button  @click="setAsValidEmail(2)" class="btnSet positive d-block mb-2 text-center w-100 btn btn-sm btn-success pr-4 pl-4">
                                            <span>{{ $t('lang.button.engagement') }}</span>
                                        </button>
                                    </div>  -->
                                    <div class="mt-2" v-if=" selected.status !== 'negative' ">                         
                                        <button  @click="setAsValidEmail(3)" class="btnSet positive d-block mb-2 text-center w-100 btn btn-sm btn-danger pr-4 pl-4">
                                            <span>{{ $t('lang.button.removeemail') }}</span>
                                        </button>
                                    </div>
                                    <div class="mt-2" v-if=" selected.status !== 'valid' ">                         
                                        <button  @click="setAsValidEmail(4)" class="btnSet positive d-block mb-2 text-center w-100 btn btn-sm btn-success pr-4 pl-4">
                                            <span>{{ $t('lang.button.showemail') }}</span>
                                        </button>
                                    </div> 
                                </div>

                            </div>
                        <div class="col-sm-9 col-md-9">
                                <div>
                              <div style='min-height:180px;' class="card notEffect p-3 mb-2">
                                            <div class="">
                                                    <div class="row pt-2">
                                                        <div class="col-1"></div>
                                                        <div class="col-11">
                                                            <div class="d-flex justify-content-between align-items-center">
                                                                <div class="d-flex align-items-center">
                                                                    <h5>{{ selected.response_subject }}</h5>
                                                                    <span class="ml-2 mb-1 badge " :class="statusBadge(selected.status)">{{ selected.status }}</span>
                                                                     <span 
                                                                     v-if="selected.is_automatic == '1'"
                                                                     class="ml-2 mb-1 badge badge-primary">  automatic</span>
                                                                </div>
                                                                <div class="">
                                                                    <span class="email-info-right">{{  selected.response_date | formatDatePretty  }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row pt-3 pb-4">
                                                        
                                                        <div class="col-1">
                                                             <div class=" position-relative">
                                                                <div class="position-absolute">
                                                                    <span class="icoCircle mail"><span>
                                                                        {{ selected.response_from | firstLetter }}
                                                                       </span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-11">
                                                            <div class="d-flex justify-content-between">
                                                                <div class="">
                                                                        <span class="nameClient mb-1 d-inline font-weight-bold">{{  selected.response_from }}</span>
                                                                        <p class="nameClient mb-1 ml-2 d-inline"><{{  selected.response_from }}></p>
                                                                </div>
                                                            </div>
                                                            <p class=""><small> To: {{  selected.response_to }}</small></p>
                                                            <div class=" mt-4" >
                                                                    <div>
                                                                         <OpenAi
                                                                         v-if="false && selected.response_to"
                                                                        :email_id="selected.id">
                                                                        </OpenAi>

                                                                        <div v-if="selected.response_snippet " class="card">
                                                                        <h6>Snippet</h6>
                                                                        <p v-html="quoted_printable_decode(selected.response_snippet)" class="email-body">{{  selected.response_snippet }}</p>
                                                                        </div>

                                                                        <p v-html="quoted_printable_decode(selected.response_message)" class="email-body">{{  selected.response_message }}</p>

                                                                    </div>
                                                            </div>
                                                        </div>
                                                </div> 
                                            </div>
                                    </div>                            
                            </div>
                             <!--REPLY CARD-->
                            <replyEmail :selected="selected" :close="false"></replyEmail>
                            <!--//REPLY CARD-->
                            
                        </div>
                       
                            
                        
                        
                            
                        
                    </div>
                </div>
        </main>
    </section>
</template>
<script>


import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import Header from "@/components/Header.vue";
import OpenAi from "@/components/OpenAi/OpenAi.vue";
import replyEmail from "@/components/Emails/replyEmail.vue";
import { statusBadgeMixin, linksMixin } from "@/_mixins/";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { emailsService, monitorService, businessesService, opportunitiesService, campaignsService, businessContactsService } from "@/_services";
import  ActionButtons  from "@/components/Emails/ActionButtons.vue";
const sleep = d => new Promise(r => setTimeout(r, d));


export default {
     data() {
        return {
            emailresponsestatus:[],
            clients:[],
            textfound:'',
            tagging:false,
            loadingopenaing:false,
            openresult:false,
            autolink:false,
            errors: [],
            opportunities: [],
            oppSelected:null,
            loadingOpportunities: false,
            oppContacts: [],
            contactSelected:null,
            loadingContacts: false,
            searchOpportunities: "",
            openAiResponse:"",
            openAiLoading:false,
            searchclient:"",
            selectedCampaign: "",
            campaigns: [],
            opp: false,
            createOpp: false,
              tags: [],
              showtags: false,
              body: '',
              worddetected: ''
        }
    },
    props: {
        selectedEmailId: String
    },

    mixins: [statusBadgeMixin, linksMixin],

    components: {
        Header,
        replyEmail,
        ActionButtons,
        LoadingSpinner,  
        OpenAi  
    },

  computed: {
    ...mapState({
        loading: state => state.emails.loading,
        selected: state => state.emails.selected.data,
        currentUser: state => state.authentication.user
    }),  
    ...mapState({
        headerTab: state => state.header.tab
    })},
    
    isDisabled() {
        return this.opp;
    },

    isDisabledCO() {
        return this.createOpp;
    },

    user() {
      return this.$store.state.authentication.user;
    },

    created() {
        this.getEmailResponseStatus()
        this.getClients();
        this.getEmail();
    },

    watch: {
        loading: function() {
            this.setTargetBlank(this.loading, "email-body", sleep);
        },
    },
    
    methods: {
        ...mapActions("header", {
            changeHeaderTab: "changeTab"
        }),
         ...mapActions("emails", {
            getEmailById: "getById",
             getPriorityOpportunity: "getPriority",
            resetPriorityOpportunity: "resetPriority",
            startLoading: "startLoading",
            finishLoading: "finishLoading",
            startLoadingOpportunities: "startLoadingOpportunities",
            finishLoadingOpportunities: "finishLoadingOpportunities",
            "getAiTag" : "getAiTag"
        }),   
        getEmailResponseStatus() {
          emailsService.getEmailResponseStatus().then(result => {
            this.emailresponsestatus = result
          });
        },
        hideButtons(id){
            return (id !== '5' && id !== '4')
        },
        highlightedText(w) {
          const regex = new RegExp(w, 'gi');
          return this.body.replace(regex, '<strong class="text-success">$&</strong>');
        },
        retag(email_status_id,onlytag) {
            this.tags[this.selected.id] = ''
            this.showtags = false;
            this.tagging=true;
            
            let data = {
              'id': this.selected.response_id,
              'link_id': this.selected.link_id,
              'business_contact_id': this.selected.business_contact_id,
              'email_response_id': this.selected.id,
              'email_status_id': email_status_id,
              'only_tag' : onlytag
            }

            emailsService
            .reTagEmail(data).then((r) => {
              this.tags[this.selected.id] = r;
              if(r['analyzed'] !== undefined){
                  this.body = r['analyzed']['body'];
                  this.worddetected = r['analyzed']['worddetected'];
              }
              this.showtags = true;
              this.tagging = false;
            });
        },
        removeTagsHTML(texto) {
          let div = document.createElement("div");
          div.innerHTML = texto;
          return div.textContent || div.innerText || "";
        },
        checkForm(e) {
            this.errors = [];
            if (!this.searchOpportunities) {
                this.errors.push("This field can not be blank.");
                return false;
            }
            if(this.searchOpportunities.length < 3){
                this.errors.push("Enter at least three letters.");
                return false;
            }
            if (!this.errors.length) {
                return true;
            }
            e.preventDefault();
            
        }, 
        getClients(){
            monitorService.getClients().then((result) => {
              this.clients = result;
            });
        },
        quoted_printable_decode (str) { // eslint-disable-line camelcase
        

         if(str && str.indexOf('=E9') && !str.indexOf('http'))  {


         var RFC2045Decode1 = /=\r\n/gm
          // the RFC states against decoding lower case encodings, but following apparent PHP behavior
          var RFC2045Decode2IN = /=([0-9A-F]{2})/gim
          var RFC2045Decode2OUT = function (sMatch, sHex) {
            return String.fromCharCode(parseInt(sHex, 16))
          }

          return str.replace(RFC2045Decode1, '')
            .replace(RFC2045Decode2IN, RFC2045Decode2OUT)

         }
        
        return str;



        },    
        getEmail() {
                this.searchEmail();
        },
        searchEmail() {
            this.getEmailById({
                id: this.selectedEmailId 
            })
        },
        searchContacts(){
            this.loadingContacts = true;
            opportunitiesService.getContacts(this.selected.link_id)
            .then(result => {
                this.oppContacts = result;
            }).then(result=> {
                this.loadingContacts = false;
            });
        },
        deleteEmail() {
                this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.areyousure'),
                    text: this.$t('lang.label.youwontbeabletorevertthis'),
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: this.$t('lang.label.yesdeletethem')
                }).then((result) => {
                    if (result.value) {
                                this.$swal({
                                    type: 'success',
                                    title: this.$t('lang.label.deleted'),
                                    text: this.$t('lang.label.emailhasbeendeleted'),
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                    }
                })
        },
        
       
    qualifiedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          8,
          qualificationOptions.linkId,
          qualificationOptions.statusReason
        )
        .then(data => {
          this.searchEmail();
        });
    },
     disqualifiedOpportunity(qualificationOptions) {
      this.startLoading();
      opportunitiesService
        .changeStatus(
          5,
          qualificationOptions.linkId,
          qualificationOptions.statusReason,
          qualificationOptions.nextCampaignId,
          qualificationOptions.campaignDate
        )
        .then(data => {
          this.searchEmail();
        });
    },
         doNotContactBusiness(qualificationOptions) {
            this.$swal({
                type: "warning",
                title: this.$t('lang.label.areyousure'),
                text: this.$t('lang.label.donotcontactthisbusiness'),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33a2c",
                confirmButtonText: this.$t('lang.label.yesdonotcontactthem')
            }).then(result => {
                if (result.value) {
                this.startLoading();
                opportunitiesService
                    .changeStatus(
                    10,
                    qualificationOptions.linkId)
                    .then(data => {
                    this.searchEmail();
                    });
                }
            });
            },
            deleteBusiness(qualificationOptions) {
                this.$swal({
                    type: "warning",
                    title: this.$t('lang.label.areyousure'),
                    text: "this.$t('lang.label.youaregoingtodelete') ${this.selected.business_name}",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33a2c",
                    confirmButtonText: this.$t('lang.label.yesdeletethem')
                }).then(result => {
                    if (result.value) {
                    this.startLoading();
                    opportunitiesService
                    .changeStatus(
                    11,
                    qualificationOptions.linkId)
                    .then(data => {
                    this.searchEmail();
                    });
                }
                });
            },

        changeTab(selectedTab) {
            this.changeHeaderTab({ tab: selectedTab });
        },
        setAsValidOpportunity(event){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.setasvalidopportunity'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'ok'
                }).then((result) => {
                    if (result.value) {
                                this.$swal({
                                    type: 'success',
                                    title: this.$t('lang.label.great'),
                                    text: "",
                                    showConfirmButton: false,
                                    timer: 1500
                                })
                    }
                })
        },
        getOpportunities(){
             this.loadingOpportunities = true;
             this.searchclient = this.selected.client_id
            opportunitiesService.getListOpportunities(this.searchOpportunities,this.searchclient)
            .then(result => {
                this.opportunities = result;
            }).then(result=> {
                this.loadingOpportunities = false;
            });
            
        },
        getContacts(){
           
            opportunitiesService.getContacts(this.selected.link_id)
            .then(result => {
                this.oppContacts = result;
            }).then(result=> {
               
            });
            
        },
        confirmSearch() {
            if(this.checkForm()){
                this.getOpportunities();
            }
        },
        autoLink(response_id,response_to,id){
             this.startLoading();
            opportunitiesService.autoLink(response_id,response_to,id).then(res => {
                if(res !== null){
                    this.getClients();
                    this.getEmail();
                }else{
                    this.oppSelected = null
                }
                this.finishLoading()
               
            })

        },
        resetSearch() {
            this.searchOpportunities = "";
            this.opportunities = [];
        },
        opportunitySelected(opportunity){
            this.resetSearch();
            this.oppSelected=opportunity;
        },
        resetOppSelected() {
            this.oppSelected = null;
        },
        contactSelect(contact){
            this.contactSelected=contact;
        },
        resetContactSelected() {
            this.contactSelected = null;
        },
        associateOpportunity(){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.setopportunity'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                 if (result.value) {
                    this.opp = true;
                    this.startLoading();
                    emailsService.associateOpportunity( this.selectedEmailId ,this.oppSelected)
                    .then(emails => {
                        this.$swal({
                        type: "success",
                        title: this.$t('lang.label.great'),
                        text: this.$t('lang.label.emailassociatedsuccessfully'),
                        showConfirmButton: false,
                        timer: 1500
                        }).then(result => {
                        this.$emit("associateOpportunity");
                        });
                    }).then(result=> {
                        this.searchEmail();
                    });
                 }    
             });
        },
        createOpportunity(){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.setopportunity'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                 if (result.value) {
                    this.createOpp = true;
                    this.startLoading();
                    emailsService.createOpportunity(this.selectedEmailId)
                    .then(emails => {
                        this.$swal({
                        type: "success",
                        title: this.$t('lang.label.great'),
                        text: this.$t('lang.label.emailassociatedsuccessfully'),
                        showConfirmButton: false,
                        timer: 1500
                        }).then(result => {
                        this.$emit("associateOpportunity");
                        });
                    }).then(result=> {
                        this.searchEmail();
                    });
                 }    
             });
        },
        associateBusinessContact(){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.setcontact'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                 if (result.value) {
                    this.startLoading();
                    emailsService.associateBusinessContact( this.selectedEmailId ,this.contactSelected)
                    .then(emails => {
                        this.$swal({
                        type: "success",
                        title: this.$t('lang.label.great'),
                        text: this.$t('lang.label.emailassociatedsuccessfully'),
                        showConfirmButton: false,
                        timer: 1500
                        }).then(result => {
                        this.$emit("associateBusinessContact");
                        });
                    }).then(result=> {
                        this.searchEmail();
                    });
                 }    
             });    

        },

        openAiTag(){
            this.openAiLoading = true
            emailsService.getAiTag(this.selectedEmailId).then((res)=>{
                this.openAiResponse = res.openairesponse
                this.openAiLoading = false
            })
        },

        setAsValidEmail(status_id){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.areyousure'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                 if (result.value) {
                    this.startLoading();
                    emailsService.setValidStatus( this.selectedEmailId ,status_id, this.selected.response_message)
                    .then(emails => {
                        this.$swal({
                        type: "success",
                        title: this.$t('lang.label.great'),
                        text: this.$t('lang.label.emailsetasvalidsuccessfully'),
                        showConfirmButton: false,
                        timer: 1500
                        }).then(result => {
                        this.$emit("setAsValidEmail");
                        });
                    }).then(result=> {
                        this.searchEmail();
                    });
                 }    
             });    

        },

        changeStatusBusinessContactAction(statusId,client_id){
            this.$swal({
                    type: 'warning',
                    title: this.$t('lang.label.areyousure'),
                    text: "",
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33a2c',
                    confirmButtonText: 'Ok'
                }).then((result) => {
                 if (result.value) {
                    this.startLoading();
                    businessContactsService.changeStatus(this.selected.business_contact_id, statusId,client_id)
                    .then(emails => {
                        this.$swal({
                        type: "success",
                        title: this.$t('lang.label.great'),
                        text: this.$t('lang.label.emailsetasvalidsuccessfully'),
                        showConfirmButton: false,
                        timer: 1500
                        }).then(result => {
                        this.$emit("setAsValidEmail");
                        });
                    }).then(result=> {
                        this.changeTab('ALL');
                    });
                 }    
             });
        }
   
   
    }

}

</script>
<style>
.email-body {
    white-space: pre-wrap;
}

.email-body * {
    white-space: initial;
}
.md-chip{
    height: 32px;
    padding: 0 12px;
    display: inline-block;
    cursor: default;
    border-radius: 32px;
    transition: .3s cubic-bezier(.25,.8,.25,1);
    transition-property: background-color,color,opacity,transform,box-shadow;
    will-change: background-color,color,opacity,transform,box-shadow;
    font-size: 13px;
    line-height: 32px;
    vertical-align: middle;
    white-space: nowrap;
    cursor: pointer;
}
.md-default{
    background-color:rgb(162, 158, 158);
    color:white;
}
.content-search-opp{
    position: relative;
}
.list-result-opp{
    position: absolute;
    background-color: white;
    top: 5px;
    width: 100%;
}
.list-result-opp li{
    padding: 5px;
    font-size: 13px;
    font-weight: 600;
}
.list-result-opp li:hover{
    background-color:rgb(217, 212, 212);
    cursor: pointer;
    
}
.list-result-opp li:first-child{
    padding-top: 0;
    padding-bottom: 0;
    font-size: 14px;
    max-height: 8px;
}
.list-result-opp li:first-child:hover{
    background-color: transparent;
}
.c-pointer{
    cursor: pointer;
}
.divider{
    background-color: rgba(0,0,0,.12);
    margin-top: -1px;
    height: 1px;
    margin: 0;
    padding: 0;
    display: block;
    border: 0;
    transition: margin-left .3s cubic-bezier(.4,0,.2,1);
    will-change: margin-left;
}
.list{
    padding: 1.2em !important;
}

.content-search-opp .loading-spinner {
    width: 3rem;
    height: 3rem;
}

.content-search-opp .spinner-container {
    height: auto;
}

</style>